import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { DataModelBuilderViewModel } from "../datamodel/dataModelBuilder/dataModelBuilder-viewModel";
import { FormBuilderViewModel, GetAllNoMediaTemplateMessage, GetAllTemplateMessage } from "./formBuilder/formBuilder-viewModel";
import  { FormBuilderWindowView } from "./formBuilderWindow-view"
import { ViewModelBuilderViewModel } from "./viewModelBuilder/viewModelBuilder-viewModel";
import { FormBuilderPartViewModel } from "./viewModelBuilder/formBuilderPart/formBuilderPart-viewModel";
import { PreviewFormViewModel } from "src/bpms/execution/previewForm/previewForm-viewModel";
export class FormBuilderWindowViewModel extends ViewModel{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.formBuilder = new FormBuilderViewModel(this);
        this.dataModelBuilder = new DataModelBuilderViewModel(this);
        this.parts = ObservableArray.create<FormBuilderPartViewModel>();
        // let formBuilderTab = new form
        this.parts.push(...[new FormBuilderPartViewModel(this,'Ui Builder',this.formBuilder),new FormBuilderPartViewModel(this,'View Model',this.dataModelBuilder)]);
        this.selectedPart = this.parts[0];
    }
    GetDefaultView(): View <ViewModel> {
        return new FormBuilderWindowView();
    }
    public getTypeId(): string {
        return "VM-EA1E05B4-2F58-41A5-842C-88FAB8C32CDF"
    }

    public set formBuilder(v: FormBuilderViewModel) { this._formBuilder = v; } public get formBuilder(): FormBuilderViewModel { return this._formBuilder;} private _formBuilder: FormBuilderViewModel;
    public set dataModelBuilder(v: DataModelBuilderViewModel) { this._dataModelBuilder = v; } public get dataModelBuilder(): DataModelBuilderViewModel { return this._dataModelBuilder;} private _dataModelBuilder: DataModelBuilderViewModel;
    public set parts(v: ObservableArray<FormBuilderPartViewModel>) { this._parts = v; } public get parts(): ObservableArray<FormBuilderPartViewModel> { return this._parts;} private _parts: ObservableArray<FormBuilderPartViewModel>;
    
    private lastDataModel:any;

    public disposeComponents(){
        this.dataModelBuilder.dispose();
        this.formBuilder.dispose();
    }

    hasUnsavedChanges(): boolean {
        if(this.dataModelBuilder==null || this.formBuilder==null)
            return false;
        let newDataModel = this.dataModelBuilder.getDataModelJson();
        let isDataModelChanged = JSON.stringify(newDataModel)!=JSON.stringify(this.lastDataModel);
        return (this.dataModelBuilder.hasUnsavedChanges() || isDataModelChanged || this.formBuilder.hasUnsavedChanges()); 
    }
    
    public set selectedPart(v: FormBuilderPartViewModel) { 
        if(v==this.parts[0]){
            if(this._selectedPart!=null){
                let newDataModel = this.dataModelBuilder.getDataModelJson();
                if(JSON.stringify(newDataModel)!=JSON.stringify(this.lastDataModel) || this.dataModelBuilder.hasUnsavedChanges()){
                    let confirmationResult = confirm('Do you want to save data before closing?');
                    if(confirmationResult==true)
                        return;
                    else{
                        let newDataModelBuilder = new DataModelBuilderViewModel(this);
                        newDataModelBuilder.updateModelFromJson(this.lastDataModel);
                        this.dataModelBuilder?.dispose();
                        this.dataModelBuilder = newDataModelBuilder;
                        this.parts[1].content = newDataModelBuilder;
                    }
                }
            }

            let newFormBuilder = new FormBuilderViewModel(this);
            let dataModel = this.dataModelBuilder.getDataModelJson();
            
            let json = this.formBuilder.serailize();

            newFormBuilder.updateModelFromJson(dataModel);
            newFormBuilder.deserialize(json);
            this.formBuilder = newFormBuilder;
            this.parts[0].content = newFormBuilder;
        }else if(v==this.parts[1]){
            if(this.formBuilder.hasUnsavedChanges()){
                let confirmationResult = confirm('Do you want to save data before closing?');
                if(confirmationResult==true)
                    return;
                else
                    this.formBuilder.rejectChanges();
            }
            
            let dataModel = this.dataModelBuilder.getDataModelJson();
            let newDataModelBuilder = new DataModelBuilderViewModel(this);
            newDataModelBuilder.updateModelFromJson(dataModel);
            this.dataModelBuilder.dispose();
            this.dataModelBuilder = newDataModelBuilder;
            this.parts[1].content = newDataModelBuilder;
        }
        this._selectedPart = v; 
    } public get selectedPart(): FormBuilderPartViewModel { return this._selectedPart;} private _selectedPart: FormBuilderPartViewModel;

    updateDataModel(){
        let dataModel = this.dataModelBuilder.getDataModelJson();
        this.lastDataModel = dataModel;
        this.formBuilder.updateModelFromJson(dataModel);
    }

    getSerializedData() {
        let dataModel = this.dataModelBuilder.getDataModelJson();
        let formData = this.formBuilder.serailize();
        return {
            DataModel : dataModel,
            FormData : formData
        };
    }
    deserialize(info: any) {
        let dataModel = info.DataModel;
        let formData = info.FormData;
        this.dataModelBuilder.updateModelFromJson(dataModel);
        this.formBuilder.updateModelFromJson(dataModel);
        this.formBuilder.deserialize(formData);

        this.lastDataModel = info.DataModel;
    }
    
    override handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllTemplateMessage){
            return this.formBuilder.handleMessage(msg);
        }else if(msg instanceof GetAllNoMediaTemplateMessage){
            return this.formBuilder.handleMessage(msg);
        }else if(msg instanceof PreviewFormBuilderFormMessage){
            msg.dataModel = this.dataModelBuilder.getDataModelJson();
            let popup = new PreviewFormViewModel(this);
            popup.preview(msg)
            this.requestShowingPopup(popup);
        }else{
            return super.handleMessage(msg);
        }
    }

}

export class PreviewFormBuilderFormMessage extends ViewModelMessage{
    currentJsonInfo:any;
    currentHtml:string;
    allTemplates:any;
    toShowTemplate:any;
    dataModel:any;
}